import { render, staticRenderFns } from "./Details.html?vue&type=template&id=f4cf850e&external"
import script from "./Dispenses.vue?vue&type=script&lang=js"
export * from "./Dispenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports